"use strict";
const molliePendingSelector = '.js-mollie_pending';
const pollSelector = '.js-mollie_pending_poll';
const timeoutSelector = '.js-mollie_pending_timeout';
const pollingLimitMs = 5 * 60 * 1000;
function showTimeoutMessage(element) {
    const poll = element.querySelector(pollSelector);
    if (poll) {
        window.up.destroy(poll);
    }
    const timeoutMessage = element.querySelector(timeoutSelector);
    if (timeoutMessage) {
        timeoutMessage.hidden = false;
    }
}
// `up-poll` swaps only the polled element. A poll answer that comes from a redirect
// (card saved, payment failed) is another page without that element, so it is rendered
// into the main target with the redirect's URL, like a followed link.
// The limit is checked on a still-pending answer, not on the clock: Unpoly does not poll
// a hidden tab, so a member who comes back after the limit still gets one more poll.
function handlePollAnswer(element, event, limitReached) {
    if (!window.up.util.matchURLs(event.request.url, event.response.url)) {
        Object.assign(event.renderOptions, { target: ':main', history: true, scroll: 'top' });
    }
    else if (limitReached) {
        event.skip();
        showTimeoutMessage(element);
    }
}
window.up.compiler(molliePendingSelector, (element) => {
    let limitReached = false;
    const timer = window.setTimeout(() => (limitReached = true), pollingLimitMs);
    const unbindLoaded = window.up.on(document, 'up:fragment:loaded', undefined, event => {
        if (event.origin !== undefined && element.contains(event.origin)) {
            handlePollAnswer(element, event, limitReached);
        }
    });
    return () => {
        window.clearTimeout(timer);
        unbindLoaded();
    };
});
